import ModalForm from 'components/commons/modal-form'
import { InlineError, Input } from 'avo-ui'
import Select from 'components/commons/select'
import Datepicker from 'components/commons/datepicker'
import moment from 'moment'

export const FormBenefitRedeemPoint = ({
    show,
    onHideForm,
    dataBenefitRedeemPoint,
    options,
    onSearchOptions,
    isLoading,
    onChangeForm,
    errorForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[730px]'}
            classNameContent={'!max-h-fit'}
            show={show}
            onHide={onHideForm}
            title={`${!dataBenefitRedeemPoint?.id ? 'Create' : 'Update'} Benefit Redeem Point`}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nama Benefit</div>
                    <Input
                        className={'flex-1'}
                        name={'name'}
                        placeholder={'Masukkan nama benefit'}
                        value={dataBenefitRedeemPoint?.name}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.name} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Type</div>
                    <Select
                        name={'type'}
                        className={'flex-1'}
                        optionsClassName={'max-h-40'}
                        placeholder={`Pilih type`}
                        options={options?.type}
                        value={dataBenefitRedeemPoint?.type}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.type} />
                </div>
                {dataBenefitRedeemPoint?.type?.value === 'free-gift' ? (
                    <div className={'flex items-start gap-x-2'}>
                        <div className={'flex flex-col space-y-3 w-3/4'}>
                            <div className={'font-semibold text-blue-90 required'}>Pilih Gift</div>
                            <Select
                                name={'benefit_id'}
                                className={'flex-1'}
                                optionsClassName={'max-h-40'}
                                placeholder={'Pilih gift'}
                                options={options?.gift}
                                searchable
                                value={dataBenefitRedeemPoint?.gift?.benefit_id}
                                onChange={(value) => onChangeForm(value, 'gift')}
                                onSearch={(keyword) => onSearchOptions(keyword)}
                            />
                            <InlineError className='mt-2' message={errorForm?.gift?.benefit_id} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Qty</div>
                            <Input
                                type={'number'}
                                className={'flex-1'}
                                name={'quantity'}
                                placeholder={'Masukkan kuantitas'}
                                value={dataBenefitRedeemPoint?.gift?.quantity}
                                onChange={(value) => onChangeForm(value, 'gift')}
                            />
                            <InlineError className='mt-2' message={errorForm?.gift?.quantity} />
                        </div>
                    </div>
                ) : (
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Nilai Potongan</div>
                        <Input
                            type={'currency'}
                            addonBefore={'Rp'}
                            className={'flex-1'}
                            name={'discount_amount'}
                            placeholder={'Masukkan nilai potongan'}
                            value={dataBenefitRedeemPoint?.discount_amount}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.discount_amount} />
                    </div>
                )}
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nilai Penukaran Point</div>
                    <Input
                        type={'number'}
                        className={'flex-1'}
                        name={'point_needed'}
                        placeholder={'Masukkan nilai penukaran point'}
                        value={dataBenefitRedeemPoint?.point_needed}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.point_needed} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Mulai Berlaku</div>
                    <div className={'flex space-x-2 justify-between'}>
                        <div className={'flex-1'}>
                            <Datepicker
                                name={'start-date'}
                                maxDate={dataBenefitRedeemPoint?.end_date}
                                minDate={moment()}
                                value={dataBenefitRedeemPoint?.start_date}
                                onChange={(value) => onChangeForm({ name: 'start_date', value })}
                                format='YYYY-MM-DD'
                                isClearable
                            />
                            <InlineError className='mt-2' message={errorForm?.start_date} />
                        </div>
                        <div className={'mt-2.5'}>-</div>
                        <div className={'flex-1 '}>
                            <Datepicker
                                name={'end-date'}
                                minDate={dataBenefitRedeemPoint?.start_date || moment()}
                                value={dataBenefitRedeemPoint?.end_date}
                                onChange={(value) => onChangeForm({ name: 'end_date', value })}
                                format='YYYY-MM-DD'
                                isClearable
                            />
                            <InlineError className='mt-2' message={errorForm?.end_date} />
                        </div>
                    </div>
                </div>
            </div>
        </ModalForm>
    )
}
